<template>
  <v-container>
    <our-progress
      v-if="(item.goal||{}).enabled"
      :goal="item.goal"
      :amount="brain.amount"
      :success="finished"
      class="mb-6"
    />

    <v-stepper
      v-if="!finished"
      v-model="idx"
      non-linear
      flat
    >
      <v-stepper-items>
        <v-stepper-content
          v-for="(step, i) in steps"
          :key="`sc_${i}`"
          :step="i+1"
          class="pa-4"
        >
          <component
            :is="step.component"
            class="pa-0"
            :item="item"
            :brain="brain"
            :auth="auth"
            :step="idx"
            @dump="brainDump"
            @next="next"
            @sayThankYou="sayThankYou"
          />
        </v-stepper-content>
      </v-stepper-items>
      
      <v-stepper-header>
        <template
          v-for="(step, i) in steps"
        >
          <v-stepper-step
            :key="`ss_${i}`"
            :step="i+1"
            :editable="step.editable"
          >
            {{ step.name }}
          </v-stepper-step>

          <v-divider
            v-if="i !== (steps.length - 1)"
            :key="`d_${i}`"
          />
        </template>
      </v-stepper-header>
    </v-stepper>
    
    <thank-you
      v-if="finished"
      :message="item.subscription.thank_you_message"
    />
  </v-container>
</template>

<script>
import OurProgress from './Progress'
import StepSubscription from './subscription/Index'
import StepAccount from './account/Index'
import StepPayment from './payment/Index'
import ThankYou from './ThankYou'

export default {
  name: 'BuyNow',
  components: {
    OurProgress,
    StepSubscription,
    StepAccount,
    StepPayment,
    ThankYou
  },
  props: {
    item: {
      type: Object,
      default: ()=>{return {}}
    },
  },
  data(){
    ThankYou
    return {
      idx: 1,
      steppers: {
        options: {
          editable: true,
          active: true,
          hold: false,
          component: StepSubscription
        },
        account: {
          editable: false,
          active: true,
          hold: true,
          component: StepAccount
        },
        payment: {
          editable: false,
          active: true,
          component: StepPayment
        },
      },
      brain: {},
      finished: false
    }
  },
  computed: {
    steps(){
      return Object.values(this.steppers).filter(s=>s.active)
    }
  },
  watch: {
    item(){
      this.idx = 1
      this.logic()
    }
  },
  methods: {
    brainDump(obj){
      this.brain = {...this.brain, ...obj}
      this.logic()
    },
    logic(){
      let b = this.brain
      let s = this.steppers
      let isUser = this.auth.set
      let intervals = this.item
        && this.item.subscription
        && this.item.subscription.intervals || []

      b.express = !intervals.length
      if (b.express) {
        b.oneTime = true
      }

      // account is editable when we have an amount
      s.account.editable = !isNaN(b.amount) && b.amount >= .01

      // only paying just this once
      s.payment.editable = b.oneTime
        && !this.auth.set
      s.payment.editable = !!this.auth.set
        && this.auth.stripe.customer
        && this.auth.stripe.customer.invoice_settings
        && !!this.auth.stripe.customer.invoice_settings.default_payment_method

      s.account.hold = !this.auth.set && !b.oneTime
      s.account.active = !b.oneTime

      b.item = {
        productID: this.item._id,
        qty: '1',
        amount: b.amount,
        total: b.amount,  
        interval: intervals[b.interval_idx || 0],
        currency: (this.item && this.item.properties||{}).currency,
        currency_icon: this.item.currency_icon
      }
      b.thank_you = this.item.subscription.thank_you_message
    },
    next(){
      this.idx++
    },
    sayThankYou(){
      this.finished = true
      window.setTimeout(()=>{
        this.finished = false
        this.$emit('close')
      }, 5000)
    },
  }
}
</script>